import type React from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/search/pageContext';

export const SearchErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for Search page (error: ${error})`);
};
